import React, { useEffect, useState, useCallback } from "react";
import { TouchableOpacity, StyleSheet, Text, View } from "react-native";
import Image from "@components/common/Image";
import metrics from "@constants/metrics";
import { useNavigation } from "@react-navigation/native";

const DeliveryBanner = (props) => {
  const [show, setShow] = useState(false);
  const navigation = useNavigation();
  const {
    image_link = "",
    image_dimension_width = 1,
    image_dimension_height = 1,
    extra_data = {},
  } = props;

  const fetchDeliveryListCount = useCallback(async () => {
    let data = extra_data.count;
    if (typeof data === "number" && data > 0) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    fetchDeliveryListCount();
  }, [fetchDeliveryListCount]);

  const aspectRatio = image_dimension_width / image_dimension_height;
  const widthMinusPadding = metrics.screenWidth - 30;
  const imageHeight = widthMinusPadding / aspectRatio;

  return show ? (
    <TouchableOpacity
      onPress={() => {
        navigation.navigate("DeliveryPage");
      }}
    >
      <Image
        source={{ uri: image_link }}
        style={{
          height: imageHeight,
          width: widthMinusPadding,
          marginHorizontal: 15,
          marginVertical: 10,
          borderRadius: 10,
        }}
      />
    </TouchableOpacity>
  ) : null;
};

export default DeliveryBanner;

const styles = StyleSheet.create({});
